(() => {
  const root = document.querySelector('[data-gp-breadcrumb]:not([data-gp-ready])');
  if (!root) return;
  root.dataset.gpReady = 'true';

  const showCurrentOnMobile = () => {
    if (!window.matchMedia('(max-width: 749px)').matches) return;
    const scroller = root.querySelector('.gp-bc__list');
    if (!scroller) return;
    requestAnimationFrame(() => {
      scroller.scrollLeft = scroller.scrollWidth;
    });
  };

  showCurrentOnMobile();
  window.addEventListener('resize', showCurrentOnMobile, { passive: true });
})();
